import { render, staticRenderFns } from "./LegacyChartReferralTypes.vue?vue&type=template&id=4a1e1c6e&"
import script from "./LegacyChartReferralTypes.vue?vue&type=script&lang=ts&"
export * from "./LegacyChartReferralTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports